<template>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import router from '../../router/router';
import { ApiPath } from '../../fetch/config';
import Container from '../../utils/container.js';
import {randomLetNum } from '../../utils/utils';
import Assert from '../../utils/assert';
import Auth from '../../utils/auth';

export default {
  name: 'LoginShare',
  meta:{page:true},
  data() {
    return {
    }
  },

    created() {
      this.share();
  },
  methods: {
        share(){
            //上层控制了没有token不能进来。
            let referer = this.$route.query.referer;
            Assert.notBlank(referer,'不知道网页源');
            let token = Auth.getToken();
            if(!token){
                console.error('路由应该控制好不进入这里来的');
                let refer = location.pathname + location.search;
                router.push({name:'login',params:{'action':'begin'},query:{refer:refer}});
                return;
            }

            referer += (referer.indexOf('?')<0 ? '?' : '&') +'token=' + token;
            location.href = referer;
        },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/page/LoginShare.vue